export default {
	'history.history': 'История',
	'history.noTask': 'Без задачи',
};
